import { render } from "./About.vue?vue&type=template&id=4f07ffdb"
const script = {}
script.render = render

export default script